import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumberInput } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { restructureData } from "../../../../utils/restructureData";
import { validateOptionalTable } from "../../../../utils/validateTable";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI204_1 = ({ hide }) => {
    const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
const inputData = [
    {
      fieldName: "procurementBudgetLocalSuppliers",
      title:
        "a. What percentage of the procurement budget allocated for significant locations of operation is utilized for suppliers local to those specific operations, considering both products and services purchased locally?",
      type: "array",
      letter: "a.",
      fields: [
        {
          fieldName: "location",
          title: "Location of Operation",
          type: "text",
          placeholder: "Enter Text",
          width: "40%",
        },
        {
          fieldName: "budget",
          title: "% of Procurement Budget Utilized for Local Suppliers",
          type: "percentage",
          width: "45%",
          placeholder: "Enter Percentage",
        },
      ],
    },
  ];

  const questionData = [
    {
      fieldName: "localGeographicalBoundaries",
      title:
        "b. How does your organization define 'local' in terms of geographical boundaries for procurement purposes?",
      type: "text",
      placeholder: "Enter Text",
      letter: "b.",
    },
    {
      fieldName: "significantLocationsCriteria",
      title:
        "c. What criteria does your organization use to determine 'significant locations of operation' when assessing procurement data?",
      type: "text",
      placeholder: "Enter Text",
      letter: "c.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 = res?.data?.data?.GRI200?.procurementPractices;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      localGeographicalBoundaries: data?.localGeographicalBoundaries || "",
      significantLocationsCriteria: data?.significantLocationsCriteria || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "distance" && !validateNumberInput(value)) return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "This field is Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // let v1 = validateForm();
      let v2 = validateOptionalTable(inputData, tables, setTabErros);

      if (!v2) return;

      let transformedData2 = {
        procurementPractices: { ...restructureData(tables), ...formData },
        type: "GRI200",
        submitted204_1: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/economic-performance/205-1/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/205-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Box sx={{ display: "flex" }}> */}
      <p className={styles.section_heading} style={{marginBottom: hide ? "-1rem" : "0"}}>204 : Procurement Practices 2016</p>
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "2.5rem" }}>
        204-1 : Significant indirect economic impacts{" "}
      </p>
      {/* </Box> */}
      {/* a */}
      <DynamicTable
        {...{
          inputData,
          tables,
          setTables,
          errors: tabErrors,
          disabled: disabled,
          setErrors: setTabErros,
          data: data,
          hide
        }}
      />
      {questionData.map((el) => (
        <Box sx={{ mt: hide ? "-1rem" : "1rem" }}>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>
          <Box sx={{ ml: 2.4 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI204_1;
